module.exports = __webpack_public_path__ + "static/media/not-found.dd780ca8.gif";